import * as React from "react";
import Dropzone from 'react-dropzone';
import axios from 'axios';
import CSS from 'csstype';
import AWS from 'aws-sdk'

import { Header } from "semantic-ui-react";

require('dotenv').config()

const util = require('util');
// const sharp = require('sharp');

const AWS_ACCESS_KEY = process.env.REACT_APP_AWS_ACCESS_KEY;
const AWS_SECRET_KEY = process.env.REACT_APP_AWS_SECRET_KEY;
const BUCKET = process.env.BUCKET;

AWS.config.update({
  accessKeyId: AWS_ACCESS_KEY,
  secretAccessKey: AWS_SECRET_KEY,
  region: 'ap-northeast-1'
});

const s3 = new AWS.S3();

interface INbdProps {
}

interface INbdState {
  isUploading: boolean;
  images: any[];
}

// SDKによるアップロード
const upload_image = (file: any, bucket: string) => {

  try {
    const params = {
      Bucket: bucket,
      Key: file.name,
      ContentType: file.type,
      Body: file,
    };

    const res = s3.putObject(params).promise();
    // const putResult = await s3.putObject(params).promise();

  } catch (error) {
    console.log(error);
    return;
  }
}

const baseStyle: CSS.Properties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  // borderWidth: 2,
  // borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out"
};

const acceptStyle: CSS.Properties = {
  borderColor: "#afeeee",
  backgroundColor: "#e0ffff"
};

const rejectStyle: CSS.Properties = {
  borderColor: "#ff7f50",
  backgroundColor: "#ffe4e1"
};


class UFileUpload extends React.Component<INbdProps, INbdState> {

  constructor(props: INbdProps) {
    super(props);
    this.state = {
      isUploading: false,
      images: []
    };
    this.handleOnDrop = this.handleOnDrop.bind(this);
  }


  handleOnDrop(files: any[]) {
    this.setState({ isUploading: true });

    Promise.all(files.map(file => this.uploadImage(file)))
      .then(images => {
        this.setState({
          isUploading: false,
          images: this.state.images.concat(images)
        });
      }).catch(e => console.log(e));
  }

  uploadImage = (file: any) => {

    // public access s3 へのアップロード
    upload_image(file, 'wa-webapp-prd-public-access-1day')

    const params = {
      file_type: file.type,
      file_name: file.name
    }

    const options = {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }

    return axios.post(
      'https://app.wayama.io/api/v1/file/upload', params, options)
      .then(res => {
        const img_options = {
          headers: {
            'Content-Type': file.type
          }
        };
        return axios.put(res.data.file_upload_url, file, img_options);
      }).then(res => {
        const { name } = res.config.data;
        return {
          name,
          isUploading: true,
          url: `https://wa-webapp-prd-public-access-1day.s3-ap-northeast-1.amazonaws.com/${file.name}`
        };
      });
  }


  render() {
    return (

      <div>

        <Header as='h3'>File Upload </Header>

        <Dropzone onDrop={this.handleOnDrop} multiple maxSize={8000000} accept="image/*" >
          {({ getRootProps, getInputProps }) => (
            <div
              {...getRootProps({ className: "dropzone" })}
              style={baseStyle}
            >
              <input {...getInputProps()} />

              {this.state.isUploading ?
                <div>ファイルをアップロードしています</div> :
                <div>ファイルをドラックするかクリックしてファイルを選択してください</div>}

            </div>
          )}
        </Dropzone>


        {this.state.images.length > 0 &&
          <div style={{ margin: 30 }}>
            {this.state.images.map(({ name, url }) =>
              <img key={name} src={url} style={{ width: 200, height: 200 }} />)}
          </div>}
      </div>
    );
  }
}


export default UFileUpload;

